// extracted by mini-css-extract-plugin
var _1 = "SidebarRow-module__active--lIoz6";
var _2 = "SidebarRow-module__animateUploadProgressBarWidth--YOVUQ";
var _3 = "SidebarRow-module__animatedBackground--Q6z2j";
var _4 = "SidebarRow-module__archived--HBjVU";
var _5 = "SidebarRow-module__caretContainer--olyQp";
var _6 = "SidebarRow-module__clickable--ukMpZ";
var _7 = "SidebarRow-module__container--_tGpq";
var _8 = "SidebarRow-module__content--pToog";
var _9 = "SidebarRow-module__contentContainer--LlF1V";
var _a = "SidebarRow-module__contentTooltip--dIbAm";
var _b = "SidebarRow-module__customMenuContainer--_D8Vf";
var _c = "SidebarRow-module__icon--gtqa8";
var _d = "SidebarRow-module__indent--VlHRW";
var _e = "SidebarRow-module__isMenuOpen--vw9Oq";
var _f = "SidebarRow-module__isPublicVariant--UFb7I";
var _10 = "SidebarRow-module__menuButton--TgVja";
var _11 = "SidebarRow-module__menuButtonContainer--QFgug";
var _12 = "SidebarRow-module__menuContainer--Genji";
var _13 = "SidebarRow-module__post--Q2B3f";
var _14 = "SidebarRow-module__rightContent--gNVve";
var _15 = "SidebarRow-module__rowContainer--oYxpW";
var _16 = "SidebarRow-module__template--rSK9S";
var _17 = "SidebarRow-module__textContainer--qcuSm";
var _18 = "SidebarRow-module__topic--vsg2q";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "archived", _5 as "caretContainer", _6 as "clickable", _7 as "container", _8 as "content", _9 as "contentContainer", _a as "contentTooltip", _b as "customMenuContainer", _c as "icon", _d as "indent", _e as "isMenuOpen", _f as "isPublicVariant", _10 as "menuButton", _11 as "menuButtonContainer", _12 as "menuContainer", _13 as "post", _14 as "rightContent", _15 as "rowContainer", _16 as "template", _17 as "textContainer", _18 as "topic" }
